export default function shorterTotal(num) {
  let count = num;

  if (count >= 1e6) {
    count = (count / 1e6).toFixed(2) + 'M';
  } else if (count >= 1e3) {
    count = (count / 1e3).toFixed(1) + 'k';
  }

  return count;
}



// WEBPACK FOOTER //
// ./src/util/shorterTotal.js